(() => {
  if (customElements.get('aouhra-countdown')) return;
  class AouhraCountdown extends HTMLElement {
    connectedCallback() {
      this.refresh = () => this.tick();
      this.tick();
      clearInterval(this.interval);
      this.interval = setInterval(this.refresh, 1000);
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
    }
    remaining(now = new Date()) {
      if (this.dataset.mode === 'deadline') {
        const value = this.dataset.deadline || '';
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return NaN;
        return Math.floor((Date.parse(value) - now.getTime()) / 1000);
      }
      const midnight = new Date(now);
      midnight.setHours(23, 59, 0, 0);
      return Math.floor((midnight.getTime() - now.getTime()) / 1000);
    }
    tick() {
      const seconds = this.remaining();
      this.hidden = !Number.isFinite(seconds) || seconds < 0;
      if (this.hidden) return;
      const values = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60];
      ['hours', 'minutes', 'seconds'].forEach((unit, i) => {
        const node = this.querySelector('[data-' + unit + ']');
        if (node) node.textContent = String(values[i]).padStart(2, '0');
      });
    }
  }
  customElements.define('aouhra-countdown', AouhraCountdown);
})();
